module.exports = __webpack_public_path__ + "img/history-active.a20ba3d7.svg";